'use strict';

var CalloutDirective = function CalloutDirective() {
  return {
    restrict: 'E',
    controller: 'CalloutController',
    template: require('../templates/callout.html'),
    scope: {
      content: '@',
      target: '@'
    },
    link: function link(scope, element) {
      var callout_element = element.find('.rm-callout');
      //Show Callout
      callout_element.removeClass('rm-callout-hide');
      //Determine position of the target element the call out will be positioned against
      if (document.querySelector('.' + scope.target)) {
        var posTop = document.querySelector('.' + scope.target).getAttribute('offsetTop');
        //Adjust callout position relative to the target element
        callout_element.css('top', posTop - 30 + 'px');
        callout_element.css('left', '-2rem');
        scope.$on('rm-hide-callout', function (event, data) {
          document.querySelector('#' + data.target + '-rm-callout').addClass('rm-callout-hide');
        });
      }
    }
  };
};
CalloutDirective.$inject = [];
module.exports = CalloutDirective;